/* ============================================================
   YOLÈTE — Catalogue des TIGES
   Sur le thème, chaque tige est lue dans SA fiche Shopify (2 oct 2026,
   demande de Nathan, pour que Charlotte modifie tout depuis l'admin) :
   nom de la famille sans coloris, prix, description, photo de chaque
   coloris et liste des coloris. Le site garde une fiche par coloris
   (tige-preto-black-40…), dont dépendent les liens, le menu, le
   composeur et le panier.
   Coloris montrés = ceux de l'option Couleur de la fiche, moins ceux du
   champ « Coloris masqués sur le site » (custom.coloris_masques).
   Hors Shopify (site Vercel), repli sur composer-belts.js.
   Chargé APRÈS data.js, composer-belts.js et les données Shopify (SHOP).
   ============================================================ */
(function () {
  if (typeof PRODUCTS === 'undefined') return;

  /* Retire toutes les tiges de data.js (dont les cuirs hors book). */
  for (var i = PRODUCTS.length - 1; i >= 0; i--) if (PRODUCTS[i].type === 'tige') PRODUCTS.splice(i, 1);

  /* Cuir et largeur du site -> fiche Shopify. cart-shopify.js et produit.js
     lisent cette table (window.TIGE_HANDLE). Sur le thème, elle est refaite
     plus bas depuis la collection « Tiges du site » ; celle-ci sert de repli. */
  var TIGE_HANDLE = window.TIGE_HANDLE = {
    'preto':       { 40: '19840pr-copie', 25: 'preto' },
    'python':      { 40: 'python-1',      25: 'python' },
    'vintage':     { 40: 'vintage',       25: 'vintage-25' },
    'vintage-leo': { 40: 'vintage-leopard' }
  };
  var CUIRS = ['preto', 'python', 'vintage', 'vintage-leo'];
  var NOM_REPLI = { preto: 'Preto', python: 'Python', vintage: 'Vintage', 'vintage-leo': 'Vintage Léopard' };
  /* Les cuirs historiques gardent leur clé d'adresse (tige-preto-black-40…) */
  var CLE_CUIR = { '19840pr-copie': 'preto', 'preto': 'preto', 'python-1': 'python', 'python': 'python',
                   'vintage': 'vintage', 'vintage-25': 'vintage', 'vintage-leopard': 'vintage-leo' };

  function norm(s) { return String(s || '').trim().toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  /* Coloris Shopify -> clé des adresses du site (inchangées) et libellé français */
  var CLE = { 'BLACK': 'black', 'NOIR': 'black', 'DARK BROWN': 'brown', 'BROWN': 'brown', 'MARRON': 'brown', 'CAMEL': 'camel', 'HAVANE': 'havane' };
  var LIBELLE = { 'BLACK': 'Noir', 'NOIR': 'Noir', 'DARK BROWN': 'Marron', 'BROWN': 'Marron', 'MARRON': 'Marron', 'CAMEL': 'Camel',
                  'HAVANE': 'Havane', 'NAVY': 'Marine', 'TAUPE': 'Taupe', 'IVOIRE': 'Ivoire', 'CHERRY': 'Cerise', 'MIEL': 'Miel',
                  'KAKI': 'Kaki', 'SABLE': 'Sable', 'RUBIS': 'Rubis' };
  /* Teinte à plat d'une pastille quand le coloris n'a pas de photo de grain */
  var TEINTE = { black: '#1b1714', brown: '#5d3a22', camel: '#b07a45', havane: '#7a4a2a', navy: '#1f2a44', taupe: '#8a7a68',
                 ivoire: '#efe6d2', cherry: '#6e1f2a', miel: '#c18a3c', kaki: '#6b6a3a', sable: '#d8c3a0', rubis: '#8e1b2c',
                 chocolat: '#3f2618', bronze: '#9a5a2c', rouge: '#9e1b2a' };
  /* Pastille choisie dans Shopify (option Couleur reliée aux couleurs de la catégorie) :
     elle prime, comme pour les boucles depuis le 9 oct 2026. Sa TEINTE d'abord, son image
     seulement sans teinte : pour un cuir, Charlotte règle une couleur à plat, et l'image
     du métaobjet est souvent la photo de la ceinture (Bronze de Puma Vernis, 20 oct 2026). */
  function pastilleShopify(sp, valeur) {
    var ps = sp && sp.pastilles, s = ps && ps[valeur];
    if (ps && !s) for (var k in ps) if (norm(k) === norm(valeur)) { s = ps[k]; break; }
    if (!s) return null;
    if (s.c) return s.c;
    if (s.i) return "url('" + s.i + "') center / cover no-repeat";
    return null;
  }
  var ORDRE = ['black', 'brown', 'camel', 'havane'];
  /* Pastille ronde d'un cuir sans pastille Shopify : gros plan pris sur la face avant du
     détouré d'origine (canevas 1086 × 300, face centrée à 0,555, sans trous vers 80 %).
     Avant, la pastille montrait la ceinture entière rognée : une bande rectangulaire à
     côté des pastilles rondes choisies par Charlotte (22/10/2026). */
  function grain(img, w) { return "url('" + img + "') 80% 55.5% / " + (w === 25 ? 2400 : 1400) + "% auto no-repeat"; }
  /* Même gros plan sur un détouré déposé dans Shopify, recadré au ras de la ceinture : la
     face avant est dans le bas de l'image, lisse à gauche du passant (trous à droite sur la
     Puma Vernis). */
  function grainRas(img) { return "url('" + img + "') 14% 66% / 1200% auto no-repeat"; }
  function slug(s) { return norm(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function libelle(v) { var n = norm(v); return LIBELLE[n] || (n.charAt(0) + n.slice(1).toLowerCase()); }

  /* Nom de la famille tel que Shopify le donne, sans « Ceinture en cuir », sans
     la largeur (la fiche l'affiche à part) et sans les capitales d'origine :
     « Ceinture en cuir Preto · 40 mm » -> Preto, « VINTAGE LEOPARD » -> Vintage Léopard. */
  var ACCENTS = { Leopard: 'Léopard', Suede: 'Suède', Metalic: 'Métalic' };
  function nomFamille(titre, repli) {
    var t = String(titre || '').replace(/^(ceinture|tige)\s+(en\s+)?(cuir\s+)?/i, '')
      .replace(/\s*[·-]?\s*\d{2}\s*mm\b/gi, '').replace(/\s+/g, ' ').trim();
    if (!t) return repli;
    if (t === t.toUpperCase()) t = t.toLowerCase().replace(/(^|[\s-])\S/g, function (c) { return c.toUpperCase(); });
    return t.split(' ').map(function (w) { return ACCENTS[w] || w; }).join(' ');
  }

  /* Visuels du composeur, par cuir, largeur et clé de coloris : détourage pour
     les cartes (img), photo arrondie (photo), pastille de grain (dot). */
  var CB = (typeof COMPOSER_BELTS !== 'undefined') ? COMPOSER_BELTS : (window.COMPOSER_BELTS || []);
  var VISUEL = {};
  CB.forEach(function (b) { VISUEL[b.leather + '|' + b.w + '|' + b.color] = b; });

  var S = (typeof window !== 'undefined' && window.SHOP) || null, BYH = {};
  /* tigesSite en dernier : sa version porte la description complète */
  if (S) ['tiges40', 'tiges25', 'extra', 'tigesSite'].forEach(function (k) { (S[k] || []).forEach(function (p) { BYH[p.handle] = p; }); });
  var surShopify = Object.keys(BYH).length > 0;

  /* Thème : les tiges du site sont celles de la collection automatique
     « Tiges du site » (handle tiges-site), c'est-à-dire toute fiche portant
     l'étiquette tige-40 ou tige-25, qui donne aussi sa largeur (6 oct 2026,
     pour que Charlotte ajoute un cuir, Savane par exemple, sans toucher au code). */
  var site = (S && S.tigesSite) || [];
  if (site.length) {
    TIGE_HANDLE = window.TIGE_HANDLE = {};
    var connus = CUIRS.slice();
    CUIRS = [];
    site.forEach(function (p) {
      var tags = p.tags || [];
      var w = tags.indexOf('tige-25') !== -1 ? 25 : tags.indexOf('tige-40') !== -1 ? 40 : (/\b25\s*mm/i.test(p.title || '') ? 25 : 40);
      var cuir = CLE_CUIR[p.handle] || slug(nomFamille(p.title, p.handle)) || p.handle;
      if (!TIGE_HANDLE[cuir]) { TIGE_HANDLE[cuir] = {}; CUIRS.push(cuir); }
      if (!TIGE_HANDLE[cuir][w]) TIGE_HANDLE[cuir][w] = p.handle;
      if (!NOM_REPLI[cuir]) NOM_REPLI[cuir] = nomFamille(p.title, p.handle);
    });
    /* cuirs historiques d'abord, puis les nouveaux dans l'ordre de la collection */
    CUIRS.sort(function (a, b) {
      var ia = connus.indexOf(a), ib = connus.indexOf(b);
      return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
    });
  }

  var tiges = [], gardes = {};
  [25, 40].forEach(function (w) {
    CUIRS.forEach(function (cuir) {
      if (surShopify) {
        var h = (TIGE_HANDLE[cuir] || {})[w], sp = h && BYH[h];
        if (!sp) return;                        /* fiche absente, en brouillon ou non publiée */
        var fam = nomFamille(sp.title, NOM_REPLI[cuir]);
        var masques = (sp.masques || []).map(norm);
        var par = {}, liste = [];
        (sp.variants || []).forEach(function (v) {
          var n = norm(v.option1);
          if (!n || masques.indexOf(n) !== -1) return;
          if (!par[n]) { par[n] = { valeur: v.option1, vs: [] }; liste.push(n); }
          par[n].vs.push(v);
        });
        var prises = {};
        liste.forEach(function (n, rang) {
          var e = par[n], cle = (CLE[n] && !prises[CLE[n]]) ? CLE[n] : slug(n);
          prises[cle] = 1;
          var vis = VISUEL[cuir + '|' + w + '|' + cle] || null;
          var psh = pastilleShopify(sp, e.valeur);
          var photo = null;
          for (var j = 0; j < e.vs.length && !photo; j++) photo = e.vs[j].image || null;
          /* Détouré du composeur : champ « Photo composeur » d'une des tailles du coloris,
             ou de la fiche quand elle n'a qu'un coloris (21/10/2026). Charlotte fait entrer
             un cuir dans le composeur en y déposant sa ceinture détourée ; les détourés
             d'origine (composer-belts.js) ne servent plus que de repli. */
          var compo = null;
          for (var j2 = 0; j2 < e.vs.length && !compo; j2++) compo = e.vs[j2].compo || null;
          if (!compo && liste.length === 1) compo = sp.compoP || null;
          var prix = Math.min.apply(null, e.vs.map(function (v) { return Number(v.price) || 0; }));
          /* tailles vendables de ce coloris (« 85 » -> true), la fiche grise les autres */
          var tailles = {};
          e.vs.forEach(function (v) { var t = String(v.option2 || '').replace(/\D/g, ''); if (t) tailles[t] = !!v.available; });
          var o = {
            id: 'tige-' + cuir + '-' + cle + '-' + w, name: 'Tige ' + fam, familyName: fam,
            leather: cuir, colorKey: cle, colorValue: e.valeur, colorLabel: libelle(e.valeur),
            /* ordre de l'option Couleur de la fiche : le premier coloris est celui de la carte.
               Charlotte le choisit en faisant glisser les couleurs dans l'admin (demande de
               Luc, 22/10/2026 : pas toujours le noir en premier). */
            colorOrder: rang,
            type: 'tige', width: w, price: prix, style: null, audience: 'femme', collections: [], couleur: [], colors: [],
            img: compo || (vis ? String(vis.img || '').split('?')[0] : (photo || '')),
            compo: compo || (vis ? String(vis.img || '').split('?')[0] : null), compoShopify: !!compo,
            photo: photo || (vis && vis.photo) || '',
            /* pastille ronde : celle de Shopify, sinon le grain du détouré (d'origine, ou déposé
               dans Shopify), sinon la teinte connue */
            dot: null, dotColor: psh || (vis ? grain(String(vis.img || '').split('?')[0], w)
              : compo ? grainRas(compo) : (TEINTE[cle] || null)),
            images: [photo || (vis && vis.photo) || ''].filter(Boolean),
            descr: String(sp.descr || ''), descrHtml: String(sp.descrHtml || ''), details: String(sp.details || ''),
            shopHandle: h, tailles: tailles, available: e.vs.some(function (v) { return v.available; })
          };
          tiges.push(o);
          if (vis) { vis.name = fam + ' ' + o.colorLabel; vis.colorLabel = o.colorLabel; vis.price = prix; gardes[vis.id] = 1; }
        });
      } else {
        /* Repli hors Shopify : visuels et prix de composer-belts.js */
        CB.forEach(function (b) {
          if (b.leather !== cuir || b.w !== w) return;
          var fam = NOM_REPLI[cuir];
          tiges.push({
            id: 'tige-' + b.id, name: 'Tige ' + fam, familyName: fam, leather: cuir, colorKey: b.color,
            colorLabel: b.colorLabel, colorOrder: ORDRE.indexOf(b.color) === -1 ? 50 : ORDRE.indexOf(b.color),
            type: 'tige', width: w, price: b.price, style: null, audience: 'femme', collections: [], couleur: [], colors: [],
            img: String(b.img || '').split('?')[0], compo: String(b.img || '').split('?')[0],
            photo: b.photo, dot: b.dot, images: [b.photo].filter(Boolean),
            descr: 'Tige ' + fam + ' · ' + w + ' mm · cuir à tannage végétal, boucle interchangeable.'
          });
        });
      }
    });
  });

  /* Composeur : seuls les coloris montrés sur le site, avec le nom et le prix de Shopify. */
  if (surShopify) for (var k = CB.length - 1; k >= 0; k--) if (!gardes[CB[k].id]) CB.splice(k, 1);

  PRODUCTS.push.apply(PRODUCTS, tiges);
})();
